import qs from 'qs';
import React from 'react';
import { Query } from 'react-apollo';
import { setPreview } from '../../boot/apollo';
import { categoryQuery as deprecated_CategoryQuery, productQuery as deprecated_ProductQuery } from '../../data/deprecatedQueries';
import SortOrderContainer from '../SortOrder/SortOrderContainer';
import CategoryRoute from './CategoryRoute';
import ProductRoute from './ProductRoute';
import PaginationContext from '../Pagination/PaginationContext';
import logWarningInDev from '../../helpers/logWarningInDev';
const PreviewRoute = ({ productPage, categoryPage, productFragment, productQuery, categoryQuery, categoryFragment, location, StartPage }) => {
    logWarningInDev(!productQuery || !!productFragment, `PreviewRoute expects a productQuery. The productFragment syntax is deprecated and will stop working in the next major release. See https://gitlab.jetshop.se/jetshop/flight/blob/master/packages/template-trend/src/components/ProductPreviewQuery.gql for a reference implementation.`);
    logWarningInDev(!categoryQuery || !!categoryFragment, `PreviewRoute expects a categoryQuery. The categoryFragment syntax is deprecated and will stop working in the next major release. See https://gitlab.jetshop.se/jetshop/flight/blob/master/packages/template-trend/src/components/CategoryPreviewQuery.gql for a reference implementation.`);
    const { search } = location;
    const queryObject = qs.parse(search, {
        ignoreQueryPrefix: true
    });
    const { articlenumber, startpageid, categoryid } = queryObject;
    setPreview(true);
    if (articlenumber) {
        return (React.createElement(Query, { onCompleted: () => setPreview(false), query: productQuery ||
                deprecated_ProductQuery('ProductPreview', productFragment), variables: {
                articleNumber: articlenumber
            } }, result => React.createElement(ProductRoute, { result: result, component: productPage })));
    }
    else if (categoryid) {
        return (React.createElement(PaginationContext.Consumer, null, ({ offset, perPage }) => (React.createElement(SortOrderContainer, null, ({ sortOrder, direction }) => (React.createElement(Query, { onCompleted: () => setPreview(false), query: categoryQuery ||
                deprecated_CategoryQuery('CategoryPreview', categoryFragment), variables: {
                id: parseInt(categoryid, 10),
                orderBy: sortOrder,
                orderByDirection: direction,
                offset,
                first: perPage
            } }, result => (React.createElement(CategoryRoute, { result: result, component: categoryPage }))))))));
    }
    else if (startpageid) {
        return (React.createElement(StartPage, { startPageId: parseInt(startpageid, 10), location: location }));
    }
    else
        return null;
};
export default PreviewRoute;
//# sourceMappingURL=PreviewRoute.js.map